/** Formats the system-wide selection captured at summon time as the
 *  quote block prefilled into the input box (selection-aware-summon spec
 *  §3). The quote is part of the message text the user sends — there is
 *  no separate context channel. */
export function formatSelectionQuote(selection: {
  text: string;
  appName: string;
}): string {
  const quoted = selection.text
    .replace(/\r\n/g, "\n")
    .trimEnd()
    .split("\n")
    .map((line) => `> ${line}`)
    .join("\n");
  return `From ${selection.appName}:\n${quoted}\n\n`;
}
